import classNames from 'classnames';
import { useRef, useState } from 'react';
import { PauseIcon, PlayIcon } from 'tdesign-icons-react';
import { Checkbox, MessagePlugin } from 'tdesign-react';

import { EyesIcon } from '@/components/icon';
import { UserResourceType } from '@/interface/library';
import AudioEditor from '@/material/form-upload/audio/AudioEditor';
import { AudioPlayer } from '@/material/form-upload/core/player/audio/audio';

import ReviewDialog from './dialog';
import styles from './index.module.less';

export interface MediaViewerProps {
  children?: React.ReactNode;
  images: string[];
  hover?: boolean;
  defaultIndex?: number;
  checked?: boolean;
  type: UserResourceType | undefined;
  url: string;
  onCheckedChange?: (checked: boolean) => void;
}

const LibraryAudioViewer: React.FC<MediaViewerProps> = (props) => {
  const { checked = false, onCheckedChange, url } = props;

  const handleChange = (value: boolean) => {
    onCheckedChange?.(value);
  };

  const [hover, setHover] = useState(false);

  const audioRef = useRef<any>(null);

  const [isPlaying, setIsPlaying] = useState<any>(false);

  const getStatus = (status: boolean) => {
    setIsPlaying(status);
  };

  const openDialog = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    try {
      e.stopPropagation();
      setVisible(true);
    } catch (error) {
      MessagePlugin.error('该音频不支持播放');
    }
  };


  const triggerPlay = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    try {
      e.stopPropagation();
      audioRef?.current?.triggerPlay();
    } catch (error) {
      MessagePlugin.error('该音频不支持播放');
    }
  };

  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const mask = (
    <div
      onClick={() => handleChange(!checked)}
      style={{
        color: '#fff',
        height: '100%',
        zIndex: 2,
        position: 'absolute',
        width: '100%',
        borderRadius: 6,
      }}
    >
      {
        (hover) || (checked && hover)
          ? <span className={styles.browseIcon} onClick={openDialog}>
            <EyesIcon name={'browse'} />
          </span> : null
      }
      {
        hover || checked
          ? <span className={styles.checkboxIcon}>
            <Checkbox checked={checked}></Checkbox>
          </span> : null
      }
    </div>
  );

  return (
    <div style={{ position: 'relative' }}>
      <AudioPlayer
        url={url}
        playRef={audioRef}
        getStatus={getStatus}
        hiddenPlayBtn={true}
      />
      <div
        className={classNames(styles.content, { [styles.active]: checked })}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {
          (isPlaying || hover) || (checked && isPlaying && hover)
            ? <span className={styles.playAudioIcon} onClick={triggerPlay}>
              {!isPlaying ? <PlayIcon size={32} /> : <PauseIcon size={32} />}
            </span> : null
        }
        <ReviewDialog
          visible={visible}
          onClose={onClose}
          dialogConfig={{
            style: { padding: 0, width: '580px', height: '200px', border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' },
          }}
        >
          <div style={{ padding: '30px 20px 20px 20px', width: 580, height: 200, background: '#292929', borderRadius: 6 }}>
            <AudioEditor
              url={url}
              name={url}
              height={64}
              isEdit={false}
              visible={visible}
              controlStyle={{
                playIcon: { size: 24 },
                time: {
                  fontSize: 14,
                },
              }}
              controlClassName={styles.audioControl}
            />
          </div>
        </ReviewDialog>
        {props.children}
        {hover || checked ? <div className={styles.mask}>{mask}</div> : null}
      </div>
    </div>
  );
};

export default LibraryAudioViewer;
